import { PriceCompareGoodsEntity } from '@eastcoal/api/trade/interface'
import { importGoodsPriceCompareApi } from '@eastcoal/api/trade/priceCompareMember/importGoodsPriceCompare'

import { useForm } from '@eastcoal/formily/exports/react'

import { ImportExcelButton } from '@eastcoal/shared/components/ImportExcelButton'

export const ImportGoodsButton = () => {
  const form = useForm()
  const onChange = (value?: PriceCompareGoodsEntity[]) => {
    const { goods: oldGoodsValue = [] } = form.values
    form.setValuesIn('goods', oldGoodsValue.concat(value ?? []))
  }

  return form.editable ? (
    <ImportExcelButton api={importGoodsPriceCompareApi} onChange={onChange} />
  ) : null
}
